import bildJa from '@/assets/icons/ja.svg';
import bildNein from '@/assets/icons/nein.svg';
import bildUberspringen from '@/assets/icons/arrow.svg';

export const wishPVAnswers = [
    { name: 'Ja', available: true, value: 'ja', api: '22484', image: bildJa },
    { name: 'Nein', available: true, value: 'nein', api: '22485',  image: bildNein },
    { name: 'Überspringen', available: true, value: 'unknown', api: null,  image: bildUberspringen },
];

export const wishPVApi = {parameter: '19388',  type: 'value_choice' };